<template>
  <div data-test="signin-prompt">
    <p class="text-sm text-boba-grey-dark">{{ message }}</p>
    <button
      type="button"
      class="mt-3 h-12 w-full rounded-lg bg-primary-btn-bg text-primary-btn-txt text-base font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-btn-bg focus-visible:ring-offset-2 focus-visible:ring-offset-boba-sand-light"
      @click="emit('register')"
    >
      Register Now
    </button>
    <p class="mt-3 text-sm text-boba-grey-dark">
      Already have an account?
      <a :href="loginURI" class="text-boba-brown font-semibold underline underline-offset-2">Log in</a>
    </p>
  </div>
</template>
<script lang="ts" setup>
defineProps<{
  loginURI: string;
  message: string;
}>();

const emit = defineEmits<{ (e: "register"): void }>();
</script>
